// fetchBlurredResourceUrl.js
'use strict';
import fetch from '../resource/customFetch.js';
import handleFetchError from '../resource/handleFetchError.js';
import { getBlurredAssetManifestUrl } from '../resource/getMediaAsset.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';

import addMessage from '../action/addMessage.js';

import {
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch blurred resource url.
 * @kind action
 * @param {string} {messageId} - the message ID.
 * @param {string} {resourceUrl} - the original resource url.
 * @param {string} {blurredAssetType} - blurred asset types
 * @return {Promise} Action promise.
 */
const fetchBlurredResourceUrl =
  ({ messageId, resourceUrl, blurredAssetType }) =>
  async (dispatch, getState) => {
    const selectPath = ['messages', messageId, blurredAssetType];
    const fetchOptions = {
      method: 'HEAD',
      headers: getHeaders(),
    };

    const blurredUrl = getBlurredAssetManifestUrl({ resourceUrl });
    if (!blurredUrl) {
      return dispatch(
        addMessage({
          message: { id: messageId, [blurredAssetType]: resourceUrl },
        })
      );
    }

    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });

    try {
      let response = await fetch(blurredUrl, fetchOptions);
      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: blurredUrl,
        });
      }
      dispatch(
        addMessage({
          message: {
            id: messageId,
            [blurredAssetType]: blurredUrl,
          },
        })
      );
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      dispatch(
        addMessage({
          message: { id: messageId, [blurredAssetType]: resourceUrl },
        })
      );
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default fetchBlurredResourceUrl;
